import { useSelector } from 'react-redux';
import { LaunchedUnitsECOMAP } from './launchedUnits';
import { LaunchedUnitsSalesECOMAP } from './launchedUnitsSales';
import { ReleasesSalesStockECOMAP } from './releasesSalesStock';
import { SalesECOMAP } from './sales';
import { WeightedAverageECOMAP } from './weightedAverage';
import './primaryCharts.scss';

export const PrimaryCharts: React.FC = () => {
  const { isGridView } = useSelector((state: any) => state.chartsState);

  return (
    <div className={`primary-charts ${isGridView ? '' : 'list-layout'}`}>
      <LaunchedUnitsECOMAP />
      <LaunchedUnitsSalesECOMAP />
      <SalesECOMAP />
      <ReleasesSalesStockECOMAP />
      <WeightedAverageECOMAP />
    </div>
  );
};
